import {Box} from "@mui/material";
import {
    Cancel as CancelIcon,
    CheckCircle as CheckCircleIcon,
    ShoppingCart as ShoppingCartIcon,
    WatchLater as ScheduleIcon
} from "@mui/icons-material";
import PendingIcon from "@mui/icons-material/Pending";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

export function TabPanel({ children, value, index, typePanel, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`${typePanel}-tabpanel-${index}`}
            aria-labelledby={`${typePanel}-tab-${index}`}
            {...other}
            style={{ padding: "24px 0" }}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    )
}

const tabIcons = [
    {0: ShoppingCartIcon},
    {1: ScheduleIcon},
    {2: PendingIcon},
    {3: LocalShippingIcon},
    {4: CheckCircleIcon},
    {5: CancelIcon}]

export const getTabIcon = (index) => {
    const iconObj = tabIcons.find(obj => obj.hasOwnProperty(index));
    return iconObj ? iconObj[index] : null;
}